import { formatDataValue } from 'utils/formatFns';
import { getNOMValue } from './companyCarFields';

export const dealerInfoFields = {
  currentArea: {
    label: 'Current Area',
    getValue: (data) => ({
      regionCode: data?.generalInfo?.dealerInfo?.currentRegionCode,
      regionName: data?.generalInfo?.dealerInfo?.currentRegionName,
    }),
    formatValue: ({ regionCode, regionName }) => {
      const formattedRegCode = formatDataValue({ value: regionCode });
      const formattedRegName = formatDataValue({ value: regionName });
      return `${formattedRegCode} | ${formattedRegName}`;
    },
  },
  currentDealer: {
    label: 'Current Dealer',
    getValue: (data) => ({
      dealerCode: data?.generalInfo?.dealerInfo?.currentDealerCode,
      dealerName: data?.generalInfo?.dealerInfo?.currentDealerName,
    }),
    formatValue: ({ dealerCode, dealerName }) => {
      const formattedDealerCode = formatDataValue({ value: dealerCode });
      const formattedDealerName = formatDataValue({ value: dealerName });
      return `${formattedDealerCode} | ${formattedDealerName}`;
    },
  },
  currentDealerCode: {
    label: 'Current Dealer Code',
    getValue: (data) => data?.generalInfo?.dealerInfo?.currentDealerCode,
    formatValue: (value) => formatDataValue({ value }),
  },
  currentDealerName: {
    label: 'Current Dealer Name',
    getValue: (data) => data?.generalInfo?.dealerInfo?.currentDealerName,
    formatValue: (value) => formatDataValue({ value }),
  },
  dofuArea: {
    label: 'DOFU Area',
    getValue: (data) => ({
      regionCode: data?.generalInfo?.dealerInfo?.currentRegionCode,
      regionName: data?.generalInfo?.dealerInfo?.currentRegionName,
    }),
    formatValue: ({ regionCode, regionName }) => {
      const formattedCode = formatDataValue({ value: regionCode });
      const formattedName = formatDataValue({ value: regionName });
      return `${formattedCode} | ${formattedName}`;
    },
  },
  dofuDealerCode: {
    label: 'DOFU Dealer Code',
    getValue: (data) => ({
      dealerCode: data?.generalInfo?.dealerInfo?.currentDealerCode,
      dealerName: data?.generalInfo?.dealerInfo?.currentDealerName,
    }),
    formatValue: ({ dealerCode, dealerName }) => {
      const formattedCode = formatDataValue({ value: dealerCode });
      const formattedName = formatDataValue({ value: dealerName });
      return `${formattedCode} | ${formattedName}`;
    },
  },
  shipToArea: {
    label: 'Ship To Area',
    getValue: (data) => ({
      regionCode: data?.generalInfo?.dealerInfo?.shipToRegionCode,
      regionName: data?.generalInfo?.dealerInfo?.shipToRegionName,
    }),
    formatValue: ({ regionCode, regionName }) => {
      const formattedCode = formatDataValue({ value: regionCode });
      const formattedName = formatDataValue({ value: regionName });
      return `${formattedCode} | ${formattedName}`;
    },
  },
  shipToDealer: {
    label: 'Ship To Dealer',
    getValue: (data) => ({
      dealerCode: data?.generalInfo?.dealerInfo?.shipToDealerCode,
      dealerName: data?.generalInfo?.dealerInfo?.shipToDealerName,
    }),
    formatValue: ({ dealerCode, dealerName }) => {
      const formattedCode = formatDataValue({ value: dealerCode });
      const formattedName = formatDataValue({ value: dealerName });
      return `${formattedCode} | ${formattedName}`;
    },
  },
  shipToDealerAddress: {
    label: 'Ship to Dealer Address',
    isEllipsisWithTooltip: true,
    getValue: (data) => ({
      TMLI: data?.companyCar?.teamMemberLeaseIndicator,
      addressLine1: data?.generalInfo?.dealerInfo?.shipToAddressLine1,
      addressLine2: data?.generalInfo?.dealerInfo?.shipToAddressLine2,
      cityName: data?.generalInfo?.dealerInfo?.shipToCityName,
      stateCode: data?.generalInfo?.dealerInfo?.shipToStateCode,
      zipCode: data?.generalInfo?.dealerInfo?.shipToZipCode,
    }),
    formatValue: (value) => {
      const addressParts = [
        value.addressLine1 ? value.addressLine1 : '',
        value.addressLine2 ? value.addressLine2 : '',
        value.cityName ? `${value.cityName},` : '',
        value.stateCode || '',
        value.zipCode || '',
      ];

      const formattedAddress = addressParts.filter(Boolean).join(' ').trim();

      return getNOMValue({
        TMLI: value.TMLI,
        value: formattedAddress || 'N/A',
      });
    },
  },
};
